import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isSuccessConnect: false,
    // 角标数字存储
    // 左侧患者列表
    userDataList: [],
    // 右侧入案评估
    rightData: {},
    leftMenuNumber: {},
    messageNumber:0,
    messageObj:{},
    showMessageBox:1,//显示全局消息弹框
    opinionFeedbackNum:0,
    customerServiceNumber:0
  },
  mutations: {
    SOCKET_USER_DATA_LIST(state, data) {
      state.userDataList = data
    },
    GET_LEFTMENU_NUMBER(state, data) {
      state.leftMenuNumber = data
    },
    GET_MESSAGE_NUM(state, data) {
      state.showMessageBox = new Date().getTime()   
      state.messageNumber = data.intoCaseMsgNumber
      state.messageObj = data
    },
    GET_FEEDBACK_NUM(state, data) {
      state.opinionFeedbackNum = data
    }, 
    GET_CUSTOMER_NUM(state, data) {
      state.customerServiceNumber = data
    }, 
    SOCKET_RIGHT_DATA(state, data) {
    }
  },
  actions: { 
    getRightData({ commit }, data) {
    },
    getLeftMenuNumber({ commit }, data) {
      commit('GET_LEFTMENU_NUMBER', data)
    },
    getMessageNumber({ commit }, data) {
      commit('GET_MESSAGE_NUM', data)
    }, 
    getOpinionFeedbackNum({ commit }, data) {
      commit('GET_FEEDBACK_NUM', data)
    },  
    getCustomerNum({ commit }, data) {
      commit('GET_CUSTOMER_NUM', data)
    }, 
  }
})